import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions } from '../../common/components/formControls';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel >
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='name' component={Input} type='text' label={t('Parent_Name')} />
						</Col>
						<Col sm={6}>
							<Field name='child' component={Input} type='text' label={t('Parent_Child')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('Parent_LastViewedCenter')} />
						</Col>
						<Col sm={6}>
							<Field name='city' component={Input} type='text' label={t('Parent_City')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='email' component={Input} type='text' label={t('Parent_Email')} />
						</Col>
						<Col sm={6}>
							<Field name='phoneNumber' component={Input} type='text' label={t('Parent_PhoneNumber')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='isOnline' component={Input} componentClass='select' label={t('Parent_IsOnline')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
						<Col sm={3}>
							<Field name='createdFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('Parent_Created')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='createdTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'parentsFilter' })(withTranslation()(Filter));